import { useMemo } from 'react';

export const usePeriodos = (periodo: string | null | undefined) => {
  return useMemo(() => {
    if (!periodo) {
      return {
        periodoActual: "",
        periodoAnterior: "",
        periodoAnteriorPrev: "",
        periodoSiguiente: "",
        mesAnteriorNombre: "",
        mesAnteriorPrevNombre: "",
        mesActualNombre: "",
        mesSiguienteNombre: "",
        mesAnteriorPrevNombre: "",
      };
    }

    const meses = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const [year, month] = periodo.split("-").map(Number);
    const base = new Date(year, month - 1);

    const anterior = new Date(base);
    anterior.setMonth(base.getMonth() - 1);

    const anteriorPrev = new Date(base);
    anteriorPrev.setMonth(base.getMonth() - 2);

    const siguiente = new Date(base);
    siguiente.setMonth(base.getMonth() + 1);

    const formatPeriodo = (d: Date) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

    const getMesNombre = (d: Date) => meses[d.getMonth()].toUpperCase();

    return {
      periodoActual: periodo,
      periodoAnterior: formatPeriodo(anterior),
      periodoAnteriorPrev: formatPeriodo(anteriorPrev),
      periodoSiguiente: formatPeriodo(siguiente),
      mesAnteriorPrevNombre: getMesNombre(anteriorPrev),
      mesAnteriorNombre: getMesNombre(anterior),
      mesActualNombre: getMesNombre(base),
      mesSiguienteNombre: getMesNombre(siguiente),
    };
  }, [periodo]);
};



export function validarRut(rut) {
  rut = rut.replace(/\./g, "").replace(/-/g, "").replace(/\s+/g, '').toUpperCase();
  if (!/^\d{7,8}[0-9K]$/.test(rut)) return false;

  const aux = rut.slice(0, -1);
  const dv = rut.slice(-1);
  const reverted = Array.from(aux).reverse().map(Number);
  const factors = [2, 3, 4, 5, 6, 7];

  let sum = 0;
  for (let i = 0; i < reverted.length; i++) {
    sum += reverted[i] * factors[i % factors.length];
  }

  const res = (11 - (sum % 11)) % 11;
  if (res === 11) return dv === "0";
  if (res === 10) return dv === "K";
  return dv === res.toString();
}

export function formatearRut(rut) {
  rut = rut.replace(/^0+/, "").replace(/\./g, "").replace(/-/g, "").replace(/\s+/g, '');
  const cuerpo = rut.slice(0, -1);
  const dv = rut.slice(-1);
  return rut.length > 1 ? `${cuerpo}-${dv}` : rut;
}